// Modèle de données du module Vault côté client. Miroir de Docs/vault/*.schema.json : ces fichiers font foi
// (partagés avec le futur mobile) ; les tests vérifient que ce code et eux disent la même chose.

/** Valeur de `items.type` du module (identique à VaultTypes.PASSWORD côté backend). */
export const PASSWORD_TYPE = 'PASSWORD';

export const CURRENT_BODY_SCHEMA = 3;
export const CURRENT_HEADER_SCHEMA = 1;
/** Plus ancien schéma de corps encore lu (converti en schema 3 en mémoire). */
export const OLDEST_BODY_SCHEMA = 2;

export const MAX_CUSTOM_FIELDS = 50;
export const MAX_HISTORY = 50;

export const TEMPLATES = ['login', 'card', 'wifi', 'other'] as const;
export type Template = (typeof TEMPLATES)[number];

export const FIELD_TYPES = ['text', 'password', 'email', 'number', 'phone', 'url', 'date', 'totp', 'note'] as const;
export type FieldType = (typeof FIELD_TYPES)[number];

/** Champ personnalisé : `value` est un secret quand `hidden` est vrai. Les champs inconnus sont préservés. */
export interface CustomField {
  id: string;
  label: string;
  type: FieldType;
  value: string;
  hidden: boolean;
  [extra: string]: unknown;
}

export const HISTORY_ACTIONS = [
  'created',
  'password_changed',
  'username_changed',
  'url_changed',
  'notes_changed',
  'field_added',
  'field_changed',
  'field_removed',
  'expiry_changed',
  'trashed',
  'restored',
  'key_rotated',
] as const;
export type HistoryAction = (typeof HISTORY_ACTIONS)[number];

/** Entrée du journal : jamais de valeur, seulement l'action et, pour un champ personnalisé, son libellé. */
export interface HistoryEntry {
  at: string;
  by: { id: string; name: string };
  action: HistoryAction;
  label?: string;
  [extra: string]: unknown;
}

/** Corps d'un mot de passe (schema 3). Tout champ inconnu est préservé à la réécriture. */
export interface PasswordBody {
  schema: number;
  username: string;
  password: string;
  url: string;
  totp_secret: string;
  notes: string;
  expires_at?: string;
  custom_fields: CustomField[];
  history: HistoryEntry[];
  [extra: string]: unknown;
}

/** En-tête d'un mot de passe : tout ce que la liste affiche sans déchiffrer le corps (jamais le secret). */
export interface PasswordHeader {
  schema: number;
  title: string;
  username?: string;
  url?: string;
  template: Template;
  strength: 0 | 1 | 2 | 3 | 4;
  expiresAt?: string;
  trashedAt?: string;
  /** Personnes avec qui l'entrée est partagée (adresse connue du propriétaire) : le serveur ne sait pas résoudre un identifiant. */
  sharedWith?: SharedWith[];
  updatedClientAt: string;
  [extra: string]: unknown;
}

export interface SharedWith {
  id: string;
  email: string;
}

export type Strength = PasswordHeader['strength'];
